var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1852,
    height: 535,
    viewBox: "0 0 1852 535",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4034_6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1852,
    height: 535,
    rx: 120,
    fill: "#0F0F0F",
    fillOpacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.16 329.045C1078.79 309.651 1084.73 291.798 1094.97 275.485C1105.22 259.173 1118.86 246.213 1135.89 236.607L1115.77 201.807C1114.68 200.176 1114.41 198.454 1114.95 196.642C1115.5 194.829 1116.67 193.47 1118.49 192.563C1119.94 191.657 1121.57 191.476 1123.38 192.02C1125.19 192.563 1126.64 193.651 1127.73 195.282L1147.85 230.082C1163.44 223.557 1179.75 220.295 1196.79 220.295C1213.82 220.295 1230.14 223.557 1245.72 230.082L1265.84 195.282C1266.93 193.651 1268.38 192.563 1270.19 192.02C1272 191.476 1273.64 191.657 1275.09 192.563C1276.9 193.47 1278.08 194.829 1278.62 196.642C1279.16 198.454 1278.89 200.176 1277.8 201.807L1257.69 236.607C1274.72 246.213 1288.36 259.173 1298.6 275.485C1308.83 291.798 1314.77 309.651 1316.41 329.045H1077.16ZM1142.41 299.138C1146.22 299.138 1149.44 297.823 1152.07 295.191C1154.7 292.559 1156.01 289.344 1156 285.545C1156 281.746 1154.68 278.527 1152.06 275.888C1149.43 273.249 1146.22 271.936 1142.41 271.951C1138.6 271.965 1135.39 273.281 1132.75 275.899C1130.12 278.516 1128.81 281.731 1128.82 285.545C1128.82 289.358 1130.14 292.577 1132.77 295.202C1135.39 297.826 1138.6 299.138 1142.41 299.138ZM1251.16 299.138C1254.97 299.138 1258.19 297.823 1260.82 295.191C1263.45 292.559 1264.76 289.344 1264.75 285.545C1264.75 281.746 1263.43 278.527 1260.81 275.888C1258.18 273.249 1254.97 271.936 1251.16 271.951C1247.35 271.965 1244.14 273.281 1241.5 275.899C1238.87 278.516 1237.56 281.731 1237.57 285.545C1237.57 289.358 1238.89 292.577 1241.52 295.202C1244.14 297.826 1247.35 299.138 1251.16 299.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4034_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1521.25 269.05H1617V364.793H1521.25V269.05ZM1415.01 269.05H1510.75V364.793H1415.01V269.05ZM1521.25 162.793H1617V258.536H1521.25V162.793ZM1415.01 162.793H1510.75V258.536H1415.01V162.793Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M932.561 354.291C920.748 365.742 907.85 363.934 895.435 358.51C882.296 352.965 870.242 352.724 856.38 358.51C839.023 365.983 829.862 363.814 819.496 354.291C760.673 293.66 769.352 201.328 836.13 197.953C852.403 198.797 863.733 206.873 873.256 207.596C887.479 204.703 901.1 196.386 916.288 197.471C934.489 198.917 948.231 206.15 957.271 219.168C919.663 241.708 928.583 291.25 963.057 305.112C956.186 323.192 947.266 341.153 932.44 354.412L932.561 354.291ZM872.05 197.23C870.242 170.35 892.06 148.171 917.132 146.001C920.627 177.1 888.926 200.243 872.05 197.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.6 223.854H311.835V139.687C311.835 130.429 304.26 122.854 295.002 122.854H227.668C218.409 122.854 210.834 130.429 210.834 139.687V223.854H184.069C169.087 223.854 161.512 242.034 172.117 252.639L249.383 329.905C255.948 336.47 266.553 336.47 273.118 329.905L350.384 252.639C360.989 242.034 353.582 223.854 338.6 223.854ZM143.501 392.189C143.501 401.447 151.076 409.022 160.334 409.022H362.336C371.594 409.022 379.169 401.447 379.169 392.189C379.169 382.93 371.594 375.355 362.336 375.355H160.334C151.076 375.355 143.501 382.93 143.501 392.189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 525.879,
    height: 535,
    rx: 111,
    fill: "white",
    fillOpacity: 0.12
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4034_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1852,
    height: 535,
    rx: 120,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4034_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 202,
    fill: "white",
    transform: "translate(1415 162.793)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a6678f0883cb2394ac5a83819389c805.svg";
export { ForwardRef as ReactComponent };